if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        if (!activeMedia) return;

        const isMobile = window.matchMedia('(max-width: 989px)').matches;
        if (isMobile) {
          this.cullInactiveModalImages(activeMedia);
        } else {
          this.resetCulledModalMedia();
        }

        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        // Set up intersection observer for deferred media in the modal
        this.querySelectorAll('deferred-media').forEach((deferredMedia) => {
          if (!deferredMedia.getAttribute('loaded')) {
            const modalObserver = new IntersectionObserver(
              (entries) => {
                entries.forEach((entry) => {
                  if (entry.isIntersecting && !entry.target.getAttribute('loaded')) {
                    entry.target.loadContent(false);
                    modalObserver.unobserve(entry.target);
                  }
                });
              },
              {
                root: this.querySelector('[role="document"]'),
                rootMargin: '50px',
                threshold: 0.1,
              }
            );

            modalObserver.observe(deferredMedia);
          }
        });
      }

      resetCulledModalMedia() {
        this.querySelectorAll('[data-media-id]').forEach((element) => {
          element.style.display = '';
          this.getMediaImages(element).forEach((img) => this.restoreCulledImage(img));
        });
      }

      cullInactiveModalImages(activeMedia) {
        this.querySelectorAll('[data-media-id]').forEach((element) => {
          const isActive = element === activeMedia;
          element.style.display = isActive ? '' : 'none';

          this.getMediaImages(element).forEach((img) => {
            if (isActive) {
              this.restoreCulledImage(img);
            } else {
              this.cullImage(img);
            }
          });
        });
      }

      getMediaImages(element) {
        if (element.tagName === 'IMG') return [element];
        return Array.from(element.querySelectorAll('img'));
      }

      cullImage(img) {
        if (img.dataset.cullSrc != null) return;

        img.dataset.cullSrc = img.getAttribute('src') || '';
        img.dataset.cullSrcset = img.getAttribute('srcset') || '';
        img.removeAttribute('srcset');
        img.src =
          'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
      }

      restoreCulledImage(img) {
        if (img.dataset.cullSrc != null) {
          img.src = img.dataset.cullSrc;
          delete img.dataset.cullSrc;
        }
        if (img.dataset.cullSrcset != null) {
          img.srcset = img.dataset.cullSrcset;
          delete img.dataset.cullSrcset;
        }
      }
    }
  );
}
